import { AndroidOutlined, AppleOutlined, IosOutlined, LinuxOutlined, WindowsOutlined } from "@payping/icons";
import { Card, Divider, Tooltip } from "@payping/web-components";
import React from "react";
import { safeJoinPath } from "@payping/utils/string";
import { webConstants } from "@payping/utils/platformConstants";
import { useAppTranslation } from "@/utils/useAppTranslation";
import {
  downloadAndroidAppId,
  downloadIOSAppId,
  downloadLinuxAppId,
  downloadMacOSAppId,
  downloadWindowsAppId,
} from "@/assets/googleTrackIds";

const DownloadApps: React.FC = () => {
  const { t } = useAppTranslation();
  const iconContainerStyle: React.CSSProperties = {
    cursor: "pointer",
    display: "flex",
    margin: "1vh 2vh 1vh 0",
  };
  const iconStyle: React.CSSProperties = {
    fill: "black",
    height: "2.5vh",
    width: "2.5vh",
  };

  return (
    <Card.Raw>
      <Card.Raw.RowMeta title={t("overview.downloadApps.title")}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ display: "flex" }}>
            <Tooltip title="Linux">
              <a
                href={safeJoinPath(webConstants.PPNG, "t/linux")}
                style={iconContainerStyle}
                data-google-track={downloadLinuxAppId}
              >
                <LinuxOutlined style={iconStyle} />
              </a>
            </Tooltip>
            <Tooltip title="OSX">
              <a
                href={safeJoinPath(webConstants.PPNG, "t/yt0q")}
                target={"_blank"}
                rel={"noreferrer"}
                style={iconContainerStyle}
                data-google-track={downloadMacOSAppId}
              >
                <AppleOutlined style={iconStyle} />
              </a>
            </Tooltip>
            <Tooltip title="Windows">
              <a
                href={safeJoinPath(webConstants.PPNG, "t/windows")}
                style={iconContainerStyle}
                data-google-track={downloadWindowsAppId}
              >
                <WindowsOutlined style={iconStyle} />
              </a>
            </Tooltip>
          </div>
          <div style={{ display: "flex" }}>
            <Divider type="vertical" style={{ margin: 0, marginRight: "2vh" }} />
            <Tooltip title="iOS">
              <a
                href={safeJoinPath(webConstants.PPNG, "t/12SE")}
                target={"_blank"}
                rel={"noreferrer"}
                style={iconContainerStyle}
                data-google-track={downloadIOSAppId}
              >
                <IosOutlined style={iconStyle} />
              </a>
            </Tooltip>
            <Tooltip title="Android">
              <a
                href={safeJoinPath(webConstants.PPNG, "t/android")}
                style={iconContainerStyle}
                data-google-track={downloadAndroidAppId}
              >
                <AndroidOutlined style={iconStyle} />
              </a>
            </Tooltip>
          </div>
        </div>
      </Card.Raw.RowMeta>
    </Card.Raw>
  );
};

export default DownloadApps;
